import * as yup from 'yup'

export const nameValidator = yup
    .string()
    .matches(/^[A-Za-zА-Яа-яЁё\s-]+$/, 'Поле должно содержать только буквы')
